import {createReducer, on} from '@ngrx/store';
import {UserListLoadActions, UserLoadActions, UserPageActions} from '../actions/userActions';
import {User} from '../../../model/user';
import {UserPage} from '../../../model/user-page';
import {login, logout} from '../../auth/actions/auth.actions';

export const userFeatureKey = 'user';

export interface UserAppState {
  [userFeatureKey]: UserState;
}

export interface UserState {
  activeUser?: UserPage;
  userPage?: UserPage;
  loading: boolean;
  error: Error;
  userList?: User[];
}


export const initialState: UserState = {
  loading: false,
  error: undefined
};
export const reducer = createReducer(
  initialState,
  on(UserPageActions.load, (state) => ({
    ...state,
    loading: true,
  })),
  on(UserPageActions.loaded, (state, {userPage}) => ({
    ...state,
    loading: false,
    userPage: userPage,
  })),
  on(UserPageActions.errorLoading, (state, {error}) => ({
    ...state,
    error: error,
  })),

  on(login, (state) => ({
    ...state,
    loading: true,
  })),
  on(UserLoadActions.load, (state) => ({
    ...state,
    loading: true,
  })),
  on(UserLoadActions.loaded, (state, {user}) => ({
    ...state,
    activeUser: user,
    loading: false,
  })),

  on(UserLoadActions.errorLoading, (state, {error}) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(UserLoadActions.notFound, (state) => ({
    ...state,
    loading: false,
  })),
  on(UserLoadActions.notFound, (state) => ({
    ...state,
    user: undefined,
  })),
  on(logout, (state) => ({
    ...state,
    user: null
  })),
  on(UserListLoadActions.loadUser, (state) => ({
    ...state,
    loading: true,
  })),
  on(UserListLoadActions.loaded, (state, {users}) => ({
    ...state,
    userList: users,
    loading: false,
  })),
  on(UserListLoadActions.errorLoading, (state, {error}) => ({
    ...state,
    loading: false,
    error: error,
  }))
);
